import React from 'react';
import PropTypes from 'prop-types';
import StatusProgressItem from './StatusProgressItem';
import { useDimensions } from '../../services/customHooks';

function StatusProgress(props) {
  const { status, currentStatus, isOpportunity } = props;
  if (!status || status?.length === 0) {
    return null;
  }
  const currentStatusOrder = status.find(s => s.status === currentStatus);
  const { isMobile } = useDimensions();

  return (
    <>
      <div
        className={`status-progress-wrapper ${
          isOpportunity ? 'fix-status-progress-opportunity' : ''
        }`}
      >
        {isMobile ? (
          <StatusProgressItem
            text={currentStatusOrder?.text}
            isActive
            line
            hasLineRight
          />
        ) : (
          status.map((s, index) => (
            <StatusProgressItem
              key={s.status}
              text={s.text}
              line={index !== 0}
              isActive={s.order <= currentStatusOrder?.order}
            />
          ))
        )}
      </div>
    </>
  );
}

StatusProgress.propTypes = {
  status: PropTypes.arrayOf(
    PropTypes.shape({
      status: PropTypes.string,
      text: PropTypes.string,
      order: PropTypes.number,
    }),
  ),
  currentStatus: PropTypes.string.isRequired,
  isOpportunity: PropTypes.bool,
};

StatusProgress.defaultProps = {
  status: [],
  isOpportunity: false,
};

export default StatusProgress;
